import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, renderSlot as _renderSlot, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDynamicComponent as _resolveDynamicComponent, createBlock as _createBlock, normalizeClass as _normalizeClass, withCtx as _withCtx } from "vue"

const _hoisted_1 = { class: "page-wrapper__inner" }
const _hoisted_2 = { class: "controls" }
const _hoisted_3 = {
  key: 0,
  class: "track-nav-container"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TitleSelect = _resolveComponent("TitleSelect")!
  const _component_BackLink = _resolveComponent("BackLink")!
  const _component_TrackNav = _resolveComponent("TrackNav")!
  const _component_EditHotspot = _resolveComponent("EditHotspot")!
  const _component_Button = _resolveComponent("Button")!
  const _component_Modal = _resolveComponent("Modal")!
  const _component_TrackEditButton = _resolveComponent("TrackEditButton")!
  const _component_authenticated_layout = _resolveComponent("authenticated-layout")!

  return (_openBlock(), _createBlock(_component_authenticated_layout, null, {
    header: _withCtx(() => [
      _createVNode(_component_TitleSelect, {
        name: "track",
        class: "caption",
        items: _ctx.hotspotSelectItems,
        value: _ctx.hotspot?.id,
        onChange: _ctx.handleHotspotChange
      }, null, 8, ["items", "value", "onChange"])
    ]),
    default: _withCtx(() => [
      _createElementVNode("div", {
        class: _normalizeClass(["page-wrapper full-height", { loading: _ctx.isLoading }])
      }, [
        _cache[1] || (_cache[1] = _createElementVNode("div", {
          id: "mobile-nav",
          class: "hidden-lg"
        }, null, -1)),
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _renderSlot(_ctx.$slots, "back", {}, () => [
              _createVNode(_component_BackLink, {
                useHistory: !_ctx.hotspot?.isolatedActions || _ctx.editMode ? false : true,
                url: "/track"
              }, null, 8, ["useHistory"])
            ], true),
            _renderSlot(_ctx.$slots, "actionButton", {}, undefined, true)
          ]),
          (!_ctx.hotspot?.isolatedActions || _ctx.editMode)
            ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                _createVNode(_component_TrackNav, {
                  class: "visible-lg",
                  items: _ctx.hotspotNavItems,
                  currentIndex: _ctx.hotspotNavIndex,
                  onUpdate: _ctx.handleHotspotNavChange,
                  onEdit: _ctx.handleHotspotEdit,
                  canEdit: _ctx.editMode
                }, null, 8, ["items", "currentIndex", "onUpdate", "onEdit", "canEdit"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.hotspot)
            ? (_openBlock(), _createBlock(_resolveDynamicComponent(_ctx.currentComponent), {
                key: 1,
                hotspot: _ctx.hotspot,
                hotspotProgress: _ctx.hotspotProgress,
                showNext: _ctx.hasNextHotspot,
                showPrevious: _ctx.hasPreviousHotspot,
                onUpdateProgress: _ctx.handleUpdateProgress,
                onNext: _ctx.handleNextClick,
                onPrevious: _ctx.handlePreviousClick,
                onUpdateHotspot: _ctx.handleUpdateHotspot,
                onChangeOrder: _ctx.handleChangeOrder
              }, null, 40, ["hotspot", "hotspotProgress", "showNext", "showPrevious", "onUpdateProgress", "onNext", "onPrevious", "onUpdateHotspot", "onChangeOrder"]))
            : _createCommentVNode("", true)
        ])
      ], 2),
      _createVNode(_component_Modal, {
        modelValue: _ctx.showModal,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.showModal) = $event)),
        title: "hotspot.edit",
        onCancel: _ctx.handleCancel,
        onConfirm: _ctx.handleEditHotspot,
        onDismiss: _ctx.handleCancel
      }, {
        default: _withCtx(() => [
          _createVNode(_component_EditHotspot, {
            modelValue: _ctx.hotspotEditableData,
            onInputChange: _ctx.handleInputChange
          }, null, 8, ["modelValue", "onInputChange"])
        ]),
        footer: _withCtx(({ confirm, cancel }) => [
          _createVNode(_component_Button, {
            text: "common.cancel",
            onClick: cancel
          }, null, 8, ["onClick"]),
          _createVNode(_component_Button, {
            text: "common.save",
            onClick: confirm
          }, null, 8, ["onClick"])
        ]),
        _: 1
      }, 8, ["modelValue", "onCancel", "onConfirm", "onDismiss"]),
      _createVNode(_component_TrackEditButton)
    ]),
    _: 3
  }))
}